import type { FunctionComponent } from "react";

export const OctopusEVLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/octopusev-logo-light.png"
      className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
      alt="Octopus Electric Vehicles"
    />
  );
};
